import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import { SendEmailOTPResponse, SendMobileOTPResponse, VerifyEmailOTPResponse, VerifyMobileOTPResponse } from '../interfaces/raintree-response';


@Injectable({
  providedIn: 'root'
})
export class ProfileDataService extends ApiService {

  public getProfileData(): Observable<any> {
    return this.get<any>(ROUTES.PROFILE_DATA);
  }

  public uploadProfilePic(file: File):Observable<any>{
    console.log(file);
    
    const formData = new FormData();
    formData.append("ctype","profilePic");
    formData.append("profilePic",file);
    console.log(formData);
    return this.post(ROUTES.PROFILE_PIC,{
      body: formData,
    });
  }

  public getSentMobileOTP(mobile: any): Observable<SendMobileOTPResponse> {
    return this.post<SendMobileOTPResponse>(ROUTES.NEW_SEND_MOBILE_OTP,{
      body: mobile,
    },)
  }

  public getVerifyMobileOTP(VerifyMobile: any): Observable<VerifyMobileOTPResponse> {
    return this.post<VerifyMobileOTPResponse>(ROUTES.NEW_VERIFY_MOBILE_OTP,{
      body: VerifyMobile,
    },)
  }

  public getSentEmailOTP(EmailId: any): Observable<SendEmailOTPResponse> {
    return this.post<SendEmailOTPResponse>(ROUTES.NEW_SEND_EMAIL_OTP,{
      body: EmailId,
    },)
  }

  public getVerifyEmailOTP(VerifyEmailId: any): Observable<VerifyEmailOTPResponse> {
    return this.post<VerifyEmailOTPResponse>(ROUTES.NEW_VERIFY_EMAIL_OTP,{
      body: VerifyEmailId,
    },)
  }

  public sendUpdatedProfileData(bodyObj?: any): Observable<any>{
    return this.patch<any>(ROUTES.UPDATE_PROFILE,{
      body: bodyObj,
    })
  }
}
